import { getPrimaryContact } from 'library/helpers/getPrimary';
import SuperFetch from 'library/helpers/superFetch';
import WithHyperLink from 'library/hoc/withHyperLink';
import { useEffect, useState } from 'react';
import { Button, Card, Input, Table, Typography } from 'zui/Antd';

const { Text } = Typography;
const { Search } = Input;

const FloorTable = ({ siteID }) => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);

	useEffect(() => {
		setLoading(true);
		SuperFetch.get('/floors', {}, { siteID: siteID })
			.then((res) => {
				if (res.statusCode === 200) {
					setData(res.data);
					setFilteredData(res.data);
				}
				setLoading(false);
			})
			.catch((e) => setLoading(false));
	}, [siteID]);

	const handleSearch = (query) => {
		if (!query) {
			setFilteredData(data);
		} else {
			const searchResult = data.filter((object) => object.name.toLowerCase().includes(query.toLowerCase()));
			setFilteredData(searchResult);
		}
	};

	// HOC
	const FloorWithLink = WithHyperLink((a) => {
		return <Text>{a.children}</Text>;
	});

	const ButtonWithLink = WithHyperLink(() => <Button size='small'>View</Button>);

	const columns = [
		{
			title: 'Floor Name',
			dataIndex: 'name',
			key: 'name',
			ellipsis: true,
			render: (text, record) => (
				<FloorWithLink type='floor' dataID={record.floorID}>
					{text}
				</FloorWithLink>
			)
		},
		{
			title: 'Primary Contact',
			dataIndex: 'contactInformation',
			key: 'contactInformation',
			ellipsis: true,
			render: (text, record) => {
				const primaryContact = getPrimaryContact(record.contact);
				return <Text>{primaryContact.contactInformation}</Text>;
			}
		},
		{
			title: 'View Floor',
			key: 'Actions',
			align: 'center',
			render: (text, record) => (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center'
					}}
				>
					<ButtonWithLink size='small' type='floor' dataID={record.floorID}>
						View
					</ButtonWithLink>
				</div>
			),
			ellipsis: true
		}
	];

	return (
		<Card
			title={'Floors'}
			styles={{
				header: {
					fontSize: 20,
					borderBottom: 0
				},
				body: {
					paddingTop: 0
				}
			}}
		>
			<Search
				style={{ marginBottom: '10px', marginTop: '4px' }}
				placeholder='Search Floor Name'
				enterButton='Search'
				loading={false}
				onChange={(query) => {
					handleSearch(query.target.value);
				}}
				onSearch={(query) => {
					handleSearch(query);
				}}
			/>
			<Table
				loading={loading}
				columns={columns}
				dataSource={filteredData}
				pagination={{
					pageSize: 5
				}}
			/>
		</Card>
	);
};

export default FloorTable;
